var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9421",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15661",
    d: "M6.665 18.224a1.778 1.778 0 001.778 1.774h7.113a1.778 1.778 0 001.778-1.778V9.773a.445.445 0 00-.445-.445h-9.78a.444.444 0 00-.445.445zm8-12.448v-.445a1.334 1.334 0 00-1.332-1.333h-2.667a1.334 1.334 0 00-1.334 1.334v.445H6.665a.889.889 0 00-.889.889.889.889 0 00.889.889h10.669a.889.889 0 00.889-.889.889.889 0 00-.889-.889z"
  })));
}
export default SvgDeleteIcon;